import React from 'react';
import Title from 'antd/lib/typography/Title';
import {Card, Divider, Space} from 'antd';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import BraftEditor from 'braft-editor';
import {Config} from '../../config';
import {ArticleDto} from '../../scaffold';

export default function ArticleDetailCard(props: {article: ArticleDto}) {
  return (
    <Card style={{flex: 1}}>
      <div className={'text-center'}>
        <Title level={3}>{props.article.title}</Title>
        <Space>
          {props.article.department && (
            <Text type={'secondary'}>
              部门: {props.article.department}
              <Divider type={'vertical'} />
            </Text>
          )}
          {props.article.author && (
            <Text type={'secondary'}>
              作者: {props.article.author} <Divider type={'vertical'} />
            </Text>
          )}
          <Text type={'secondary'}>发布时间: {moment(props.article.publishedDate).format('YYYY-MM-DD')}</Text>
        </Space>
      </div>
      <Divider />
      <div className="braft-output-content" dangerouslySetInnerHTML={{__html: BraftEditor.createEditorState(props.article.content).toHTML() || ''}}></div>
      {props.article.attachments && props.article.attachments.length > 0 && (
        <div>
          <Divider orientation={'left'}>附件</Divider>
          {props.article.attachments.map(item => (
            <div key={item.id}>
              <a href={Config.ossPrefix + '/' + item.path} target={'_blank'}>
                {item.name}
              </a>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
